
export const CACHE_TYPE = {
    // user
    CACHE_USER_INFO: 'CACHE_USER_INFO', //用户详情

    CACHE_PERMISSIONS: 'CACHE_PERMISSIONS', //权限

    CACHE_SSO_SESSIONID: 'CACHE_SSO_SESSIONID',//用户id

    CACHE_CLIENT_CONN_SESSIONID: 'CACHE_CLIENT_CONN_SESSIONID',//连接token

};

const _setItem = (key, value)=>{
  window.sessionStorage.setItem(key, value);
}

const _getItem = (key, defaultValue) => {
  let str = window.sessionStorage.getItem(key);
  if(str) {
    return str;
  } else {
    return defaultValue;
  }
};

const _getItemParse = (key) => {
  let str = window.sessionStorage.getItem(key);
  if(str) {
    return JSON.parse(str);
  } else {
    return '';
  }
};

/**
 * ==================================================================
 * */

//用户详细信息
export const setUserInfo = (userInfo) => {
    _setItem(CACHE_TYPE.CACHE_USER_INFO, JSON.stringify(userInfo))
};
export const getUserInfo = () => {
    return _getItemParse(CACHE_TYPE.CACHE_USER_INFO)
};

//权限信息
export const setPermissions = (permissions) => {
  _setItem(CACHE_TYPE.CACHE_PERMISSIONS, JSON.stringify(permissions))
};
export const getPermissions = () => {
  return _getItemParse(CACHE_TYPE.CACHE_PERMISSIONS)
};


//权限信息
export const setSsoSession = (xcSessionId) => {
  _setItem(CACHE_TYPE.CACHE_SSO_SESSIONID, JSON.stringify(xcSessionId))
};
export const getSsoSession = () => {
  return _getItemParse(CACHE_TYPE.CACHE_SSO_SESSIONID)
};

//连接token
export const setClientConnSessionid = (clientSessionid) => {
  _setItem(CACHE_TYPE.CACHE_CLIENT_CONN_SESSIONID, JSON.stringify(clientSessionid))
};
export const getClientConnSessionid = () => {
  return _getItemParse(CACHE_TYPE.CACHE_CLIENT_CONN_SESSIONID)
};




// WEBPACK FOOTER //
// ./src/cache/Cache.js